import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of, combineLatest, Observable } from 'rxjs';
import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';

import { CompanySettings } from '../../model/company-settings';
import { CompanySettingsService } from '../../services/company-settings.service';
import * as companySettingsActions from '../actions';

@Injectable()
export class CompanySettingsEffect {
  @Effect()
  public loadCompanySettings$ = this.actions$.pipe(
    ofType<companySettingsActions.LoadCompanySettings>(
      companySettingsActions.LOAD_COMPANY_SETTINGS
    ),
    exhaustMap(() => {
      return this.companySettingsService.getCompanySettings();
    }),
    map((settings: CompanySettings) => {
      return new companySettingsActions.LoadCompanySettingsSuccess(settings);
    })
  );

  @Effect()
  public saveCompanySettings$ = this.actions$.pipe(
    ofType<companySettingsActions.SaveCompanySettings>(
      companySettingsActions.SAVE_COMPANY_SETTINGS
    ),
    switchMap((action: companySettingsActions.SaveCompanySettings) => {
      const { settings, voidReasons } = action.payload;

      const saveCalls: Observable<any>[] = [
        this.companySettingsService.saveCompanySettings(settings)
      ];

      if (voidReasons) {
        saveCalls.push(
          this.companySettingsService.saveVoidReasons(voidReasons)
        );
      }

      return combineLatest(saveCalls).pipe(
        map(([companySettings]) => {
          return new companySettingsActions.SaveCompanySettingsSuccess(
            companySettings
          );
        }),
        catchError((error: any) => {
          if (error && error.code > 10000) {
            return of(
              new companySettingsActions.SaveCompanySettingsFail({
                error,
                settings
              })
            );
          } else {
            return of(
              new companySettingsActions.SaveCompanySettingsFail({
                error:
                  'Something went wrong. Please try again or contact Support.',
                settings
              })
            );
          }
        })
      );
    })
  );

  constructor(
    private actions$: Actions,
    private companySettingsService: CompanySettingsService
  ) {}
}
